import type { LucideIcon, LucideProps } from 'lucide-react';
import { cn } from '../lib/cn.ts';

/** Icons that must mirror in RTL layouts. */
const MIRROR = new Set([
  'ArrowLeft', 'ArrowRight', 'ChevronLeft', 'ChevronRight', 'ChevronsLeft', 'ChevronsRight',
  'LogOut', 'LogIn', 'Send', 'CornerDownLeft', 'CornerDownRight', 'CornerUpLeft', 'CornerUpRight',
  'ListStart', 'ListEnd', 'Undo', 'Redo', 'Reply', 'Forward', 'MoveLeft', 'MoveRight', 'ArrowLeftRight', 'Route',
]);

export interface IconProps extends LucideProps {
  icon: LucideIcon;
  /** Force mirroring on/off; default = allowlist. */
  mirror?: boolean;
}

/** Lucide wrapper with default stroke width and RTL mirroring. */
export function Icon({ icon: Cmp, mirror, className, strokeWidth = 1.75, size = 20, ...rest }: IconProps) {
  const name = (Cmp as unknown as { displayName?: string }).displayName ?? '';
  const shouldMirror = mirror ?? MIRROR.has(name.replace(/Icon$/, ''));
  return <Cmp aria-hidden={rest['aria-label'] ? undefined : true} className={cn(shouldMirror && 'icon-mirror', 'shrink-0', className)} strokeWidth={strokeWidth} size={size} {...rest} />;
}
